import React, { useState } from "react";
import ReactDOM from "@tuteria/shared-lib/src/react-dom";
import ReviewGuarantors from "@tuteria/shared-lib/src/admin/ReviewGuarantors";
import ThemeProvider from "@tuteria/shared-lib/src/bootstrap";
import { displayToast } from "@tuteria/shared-lib/src/tutor-revamp/forms/SharedComponents";

export function unMountReviewGuarantors(id: string) {
  ReactDOM.unmountComponentAtNode(document.getElementById(id));
}

type Props = {
  guarantors: any[];
  onClose: () => void;
  onVerify: (action: "approve" | "deny") => Promise<void>;
  onUpdate: (guarantors: any[]) => Promise<void>;
};

const Component = ({ guarantors, onClose, onVerify, onUpdate }: Props) => {
  const [_guarantors, updateGuarantors] = useState(guarantors);
  // const displayToast = useToast()
  const [loading, setLoading] = React.useState({
    accept: false,
    reject: false,
  });

  const actions = {
    async onAccept() {
      try {
        setLoading({ ...loading, accept: true });
        await onVerify("approve");
      } catch (error) {
        console.log(error);
        setLoading({ ...loading, accept: false });
        displayToast({
          status: "error",
          title: "Error",
          duration: 4000,
          position: "top",
          description: "Action failed",
        });
      }
    },
    async onDelete(index: number) {
      try {
        setLoading({ ...loading, accept: true });
        const updatedGuarantors = _guarantors.filter(
          (_, itemIndex) => itemIndex !== index
        );
        await onUpdate(updatedGuarantors);
        updateGuarantors(updatedGuarantors);
        setLoading({ ...loading, accept: false });
      } catch (error) {
        console.log(error);
        setLoading({ ...loading, accept: false });
        displayToast({
          status: "error",
          title: "Error",
          duration: 4000,
          position: "top",
          description: "Action failed",
        });
      }
    },
    async onReject() {
      try {
        setLoading({ ...loading, reject: true });
        await onVerify("deny");
      } catch (error) {
        console.log(error);
        setLoading({ ...loading, reject: false });
        displayToast({
          status: "error",
          title: "Error",
          duration: 4000,
          position: "top",
          description: "Action failed",
        });
      }
    },
  };

  return (
    <ReviewGuarantors
      actions={actions}
      guanrantors={_guarantors}
      isOpen
      loading={loading}
      onClose={onClose}
    />
  );
};

type Payload = {
  guarantors: any[];
  user_id: string;
};

export function renderReviewGuarantors(
  payload: Payload,
  id: string,
  urls: { verify: string; update: string },
  callback: (...args: any[]) => void
) {
  const { guarantors, user_id } = payload;

  function onClose() {
    unMountReviewGuarantors(id);
  }

  async function onUpdate(guarantors: any[]) {
    const response = await fetch(urls.update, {
      method: "POST",
      headers: { "content-type": "application/json" },
      body: JSON.stringify({
        guarantors,
        user_id,
      }),
    });
    if (response.ok) {
      const data = await response.json();
      return data;
    }
    throw new Error(response.statusText);
  }

  async function onVerify(action: "approve" | "deny") {
    const response = await fetch(urls.verify, {
      method: "POST",
      headers: { "content-type": "application/json" },
      body: JSON.stringify({
        action,
        user_id,
      }),
    });
    if (response.ok) {
      const data = await response.json();
      callback(action);
      onClose();
      return data;
    }
    throw new Error(response.statusText);
  }
  ReactDOM.render(
    <ThemeProvider>
      <Component
        guarantors={guarantors}
        onClose={onClose}
        onUpdate={onUpdate}
        onVerify={onVerify}
      />
    </ThemeProvider>,
    document.getElementById(id)
  );
}
